<template>
  <div class="card">
    <h3 class="card-title">Visualizar diagnóstico</h3>
    <template v-if="diagnostico">
      <h4 class="">
        <span class="text-secondary">Nombre:</span>
        {{ diagnostico.nombre }}
      </h4>
      <div class="d-flex space-between">
        <button
          class="btn btn-info"
          @click="$router.push({ name: 'ListarDiagnosticos' })"
        >
          Volver
        </button>
        <div>
          <button class="btn btn-warning" @click="openEdit = true">
            Editar diagnóstico
          </button>
          <button class="btn btn-error" @click="eliminarDiagnostico">
            Eliminar diagnóstico
          </button>
        </div>
      </div>
      <modal v-if="openEdit" @close="openEdit = false">
        <editar-diagnostico
          slot="modal-body"
          :diagnostico="diagnostico"
          @saved="saved"
        ></editar-diagnostico>
      </modal>
    </template>
  </div>
</template>
<script>
import { DiagnosticosServices } from "../services/DiagnosticosServices";
import Swal from "sweetalert2";
import Modal from "@/components/elements/Modal";
import EditarDiagnostico from "./EditarDiagnostico.vue";
export default {
  name: "VerDiagnostico",
  components: {
    Modal,
    EditarDiagnostico,
  },
  data() {
    return {
      diagnostico: null,
      openEdit: false,
    };
  },
  mounted() {
    DiagnosticosServices.api.find(this.$route.params.id).then((response) => {
      this.diagnostico = response.diagnostico;
    });
  },
  methods: {
    eliminarDiagnostico() {
      Swal.fire({
        title: "Confirme",
        html: `<p>Está seguro que desea eliminar <b>${this.diagnostico.nombre}</b>?</p>`,
        icon: "question",
        showConfirmButton: true,
        confirmButtonText: "Eliminar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          DiagnosticosServices.api.delete(this.diagnostico).then((r) => {
            if (r.success) {
              Swal.fire("Éxito", "<p>Se ha eliminado con éxito</p>", "success");
              this.$router.push({ name: "ListarDiagnosticos" });
            } else {
              Swal.fire("Error", `<p>${r.message}</p>`, "error");
            }
          });
        }
      });
    },
    saved() {
      this.openEdit = false;
      DiagnosticosServices.api.find(this.diagnostico.id).then((response) => {
        this.diagnostico = response.diagnostico;
      });
    },
  },
};
</script>
